export const PENDING_INVITE_TOKEN_KEY = "pendingInviteToken";

export function getPendingInviteToken() {
  return sessionStorage.getItem(PENDING_INVITE_TOKEN_KEY) || "";
}

export function storePendingInviteToken(token) {
  const trimmed = token?.trim();
  if (!trimmed) return;
  sessionStorage.setItem(PENDING_INVITE_TOKEN_KEY, trimmed);
}

export function clearPendingInviteToken() {
  sessionStorage.removeItem(PENDING_INVITE_TOKEN_KEY);
}

export function buildInviteAcceptPath(token) {
  const trimmed = token?.trim();
  if (!trimmed) return "/invite/accept";
  return `/invite/accept?token=${encodeURIComponent(trimmed)}`;
}

export function buildAuthRedirectPath(token, authPath = "/login") {
  return `${authPath}?redirect=${encodeURIComponent(buildInviteAcceptPath(token))}`;
}

export function getSafeRedirect(search) {
  const redirect = new URLSearchParams(search).get("redirect");
  if (redirect && redirect.startsWith("/") && !redirect.startsWith("//")) {
    return redirect;
  }
  return "/";
}

export function normalizeInviteEmail(email) {
  return typeof email === "string" ? email.trim().toLowerCase() : "";
}
